const Card = ({ title, value, icon, colorClass }) => (
  <div className="bg-[#FFFFFF] p-[20px] rounded-[10px] flex items-start justify-between">
    <div className="flex flex-col items-start">
      <h3 className="text-[28px] font-semibold ">{value}</h3>
      <p className="text-[16px] ">
        {title}
      </p>
    </div>
    <img src={icon} alt="icon-tracking"/>
    
  </div>
);

export default Card;
